module.exports = __webpack_public_path__ + "img/015.f9c623d2.png";